export const DASHBOARD_THEME_STORAGE_KEY = 'trade-bot-dashboard-theme';

export const lightDashboardTheme = {
  mode: 'light',
  pageBg: '#f8fafc',
  surface: '#ffffff',
  surfaceMuted: '#f7fafc',
  surfaceElevated: '#f9fafb',
  border: '#e2e8f0',
  borderStrong: '#e5e7eb',
  textPrimary: '#1a202c',
  textSecondary: '#4a5568',
  textMuted: '#718096',
  textSubtle: '#a0aec0',
  inputBorder: '#d1d5db',
  shadowSm: '0 4px 6px rgba(0, 0, 0, 0.05)',
  shadowMd: '0 8px 25px rgba(0, 0, 0, 0.1)',
  shadowDropdown: '0 10px 25px rgba(0, 0, 0, 0.1)',
  chartGrid: '#e2e8f0',
  chartTick: '#718096',
  tooltipBg: '#ffffff',
  tooltipBorder: '#e2e8f0',
  lineChart: '#667eea',
  positive: '#38a169',
  negative: '#e53e3e',
  navHoverBg: '#f7fafc',
  navActiveBg: '#f7fafc',
  navAccent: '#667eea',
  headerIconHover: '#f7fafc',
  errorText: '#c53030',
};

export const darkDashboardTheme = {
  mode: 'dark',
  pageBg: '#0f1419',
  surface: '#1a2332',
  surfaceMuted: '#243044',
  surfaceElevated: '#1e293b',
  border: '#2d3b4f',
  borderStrong: '#334155',
  textPrimary: '#f1f5f9',
  textSecondary: '#cbd5e1',
  textMuted: '#94a3b8',
  textSubtle: '#64748b',
  inputBorder: '#475569',
  shadowSm: '0 4px 6px rgba(0, 0, 0, 0.35)',
  shadowMd: '0 8px 25px rgba(0, 0, 0, 0.5)',
  shadowDropdown: '0 10px 25px rgba(0, 0, 0, 0.45)',
  chartGrid: '#2d3b4f',
  chartTick: '#94a3b8',
  tooltipBg: '#1a2332',
  tooltipBorder: '#2d3b4f',
  lineChart: '#818cf8',
  positive: '#48bb78',
  negative: '#fc8181',
  navHoverBg: '#243044',
  navActiveBg: '#243044',
  navAccent: '#a5b4fc',
  headerIconHover: '#243044',
  errorText: '#fc8181',
};
